import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

type TransferMoneyCloseConfirmDialogProps = {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

export const TransferMoneyCloseConfirmDialog = ({
  open,
  onClose,
  onConfirm,
}: TransferMoneyCloseConfirmDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Закрыть форму?</DialogTitle>

      <DialogContent>
        <Typography variant="body2">
          У вас есть несохраненные изменения. Они будут потеряны после закрытия.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} variant="text">
          Остаться
        </Button>

        <Button onClick={onConfirm} variant="contained" color="error">
          Закрыть
        </Button>
      </DialogActions>
    </Dialog>
  );
};
